import { useSyncExternalStore } from 'react';

const subscribe = () => () => {};

/**
 * `false` during SSR/prerender AND during hydration, `true` from the first
 * client re-render on. For anything computed from "now" (a days-left
 * countdown) that a prerendered page baked in hours ago.
 *
 * Why a store and not `useEffect` + `useState`: `useSyncExternalStore` with a
 * `getServerSnapshot` of `false` is the one API React guarantees to hydrate
 * with the SERVER value and then re-render with the client one — no #418
 * mismatch, no discarded subtree. Measured 2026-09-07 on a tender page: the
 * stale «осталось 6 дней» made React throw away and rebuild the whole page on
 * the client, and Chrome recorded LCP at 6.2 s instead of the 1.2 s the
 * prerendered paint actually took. Same idiom as `useListDensity`.
 */
export function useHydrated(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => true,
    () => false,
  );
}
